import React, { useState } from "react";
import { TwoRow } from "../../core/layouts";
import AddQuestionnaireBottomContainer from "../AddQuestionnaireBottomContainer";
import AddQuestionnaireTopContainer from "../AddQuestionnaireTopContainer";
import variables from "../../themes/base/styles/variables";
import ViewQuestionnaireTopContainer from "../ViewQuestionnaireTopContainer";

const AddQuestionnaireRightContainerStyle = {
  mainStyle: {
    overflow: "unset",
    height: variables.fullHeight,
  },
  bottomSectionStyle: {
    overflow: "auto",
    flex: 1,
    marginTop: variables.marginMediumSmall,
  },
};

const AddQuestionnaireRightContainer = ({
  questionnaireName,
  setQuestionnaireName,
  questionnaireType,
  setQuestionnaireType,
  markAsPrimary,
  setMarkAsPrimary,
  questionsData,
  setQuestionsData,
  expandedKeys,
  handleExpand,
  onExpand,
  selected,
  mode,
  reAuditDueDate,
  evidenceInProgress,
  setEvidenceInProgress,
}) => {
  const [collapseTop, setCollapseTop] = useState(false);

  return (
    <TwoRow
      id="questionnaire"
      style={AddQuestionnaireRightContainerStyle.mainStyle}
      topSection={
        mode === "view" || collapseTop ? (
          <ViewQuestionnaireTopContainer
            questionnaireName={questionnaireName}
            isOperational={questionnaireType === 1}
            isPrimary={markAsPrimary}
            setCollapseTop={setCollapseTop}
            mode={mode}
            reAuditDueDate={reAuditDueDate}
          />
        ) : (
          <AddQuestionnaireTopContainer
            questionnaireName={questionnaireName}
            setQuestionnaireName={setQuestionnaireName}
            questionnaireType={questionnaireType}
            setQuestionnaireType={setQuestionnaireType}
            markAsPrimary={markAsPrimary}
            setMarkAsPrimary={setMarkAsPrimary}
            mode={mode}
            setCollapseTop={setCollapseTop}
          />
        )
      }
      bottomSectionStyle={
        AddQuestionnaireRightContainerStyle.bottomSectionStyle
      }
      bottomSection={
        <AddQuestionnaireBottomContainer
          questionsData={questionsData}
          setQuestionsData={setQuestionsData}
          expandedKeys={expandedKeys}
          handleExpand={handleExpand}
          onExpand={onExpand}
          selected={selected}
          mode={mode}
          evidenceInProgress={evidenceInProgress}
          setEvidenceInProgress={setEvidenceInProgress}
        />
      }
    />
  );
};

export default AddQuestionnaireRightContainer;
